import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';
import { keepIssuesOfVisibleProcesses } from '../model';
import {
  ChartValuesAndLabels,
  FilterValues,
  IssueChart,
} from 'shared/types/analytics';
import { get as getEnvironmentalAspects } from 'serviceWorker/db/fieldValues/environmentalAspects/environmentalAspects';
import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import { HashMap, LabelledEntity } from 'shared/types/commonView';
import {
  increaseEntitySeries,
  increaseNoneSeries,
  toSortedValuesAndLabels,
} from '../seriesCreation';
import { filterIssuesByChartFilters } from '../issueChartFilters';

export async function createSeriesAndLabelsFromIssuesWithFilters(
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  const environmentalAspects = {};
  const environmentalAspectsMap = (await getEnvironmentalAspects()).reduce(
    (map, environmentalAspect) => {
      map.set(environmentalAspect._id, {
        _id: environmentalAspect._id,
        label: environmentalAspect.label,
      });
      return map;
    },
    new Map<string, LabelledEntity>()
  );

  const filteredIssues = keepIssuesOfVisibleProcesses(
    filterIssuesByChartFilters(
      issues,
      IssueChart.environmentalAspect,
      filters,
      timezone
    ),
    additionalParams
  );

  const reducedToEnvironmentalAspectSummary = filteredIssues.reduce<
    HashMap<number>
  >((result, issue) => {
    const { environmentalAspect } = issue.extendedData;

    if (!environmentalAspect) {
      increaseNoneSeries(result, environmentalAspects);
    } else {
      increaseEntitySeries(
        result,
        environmentalAspects,
        environmentalAspectsMap.get(environmentalAspect)!
      );
    }
    return result;
  }, {});

  return toSortedValuesAndLabels(
    reducedToEnvironmentalAspectSummary,
    environmentalAspects
  );
}
